export enum ArticleAction {
  FETCH = 'FETCH',
  SAVE = 'SAVE',
}
